export default {
  getSchema: state => state.schema,
  getInitialSchema: state => state.initialSchema,
  getPages: state => state.pages,
  getModes: state => state.modes,
  getEnvironments: state => state.environments,
  getTypeOfPageEditing: state => state.typeOfPageEditing,
  getConfirmPageChanges: state => state.confirmPageChanges,
  getSelected: state => state.selected,
  getSelectedTab: state => state.selectedTab,
  getSelectedStep: state => state.selectedStep,
  getActiveTab: state => state.activeTab,
  getActiveStep: state => state.activeStep,
  getConfigLayout: state => state.configLayout,
  getCurrentMode: state => state.currentMode,
  getCurrentTemplate: state => state.currentTemplate,
  getNavItems: state => state.navItems,
  getSelectedPortal: state => state.selectedPortal,
  getSelectedModule: state => state.selectedModule,
  getSelectedEnvironment: state => state.selectedEnvironment,
  getSelectedPage: state => state.selectedPage,
  getSelectedItem: state => state.selectedItem,
  getParents: state => state.parents,
  getAccordionType: state => state.accordionType,
  getSelectedComponent: state => state.selectedComponent,
  getSidebarTab: state => state.sidebarTab
};
